import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import Toolstack from "../About/Toolstack";
import Techstack from "../About/Techstack";
import Certificate from "./cri-home";
import Projects from "./pro-home";
import Button from "react-bootstrap/Button";
import Contact from "../Contact/contact";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷🏻‍♂️
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> HTML, CSS and Javascript. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies </b> and
                also in areas related to{" "}
                <b className="purple">
                  Data Analytics
                </b> &nbsp;like&nbsp;
                <b className="purple">
                   MS Excel
                </b> &nbsp;and &nbsp;
                <b className="purple">
                   Power BI . 
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products with
              {/* with <b className="purple">Node.js</b> and */}
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js </b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
          <hr></hr>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>
        <Techstack /><hr></hr>
        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack /><hr></hr>
        <div className="pro-home2">
            <Projects/>
            <Button href="/project" className="mt-3" variant="primary">
              See More Projects
            </Button>
        </div>
        <hr></hr>
        <div className="pro-home1">
            <Certificate/>
            <Button href="/certificate" className="mt-3" variant="primary">
              See More Certificates
            </Button>
        </div>
        <hr></hr>
        <div className="pro-home1"><Contact/></div>
      </Container>
    </Container>
    
  );
}
export default Home2;
